import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { AppErrorFallback } from "./AppErrorFallback";

function toError(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }
  if (isRouteErrorResponse(error)) {
    return new Error(`${error.status} ${error.statusText}`);
  }
  return new Error(String(error ?? "Unknown route error"));
}

/**
 * Catches route-level render errors (including failed lazy chunk imports)
 * that React Router would otherwise show as "Unexpected Application Error!".
 * Chunk-load recovery is handled inside AppErrorFallback.
 */
export function RouterErrorFallback() {
  const error = toError(useRouteError());

  return (
    <AppErrorFallback
      error={error}
      resetError={() => {
        window.location.assign(window.location.href);
      }}
    />
  );
}
